module.exports = __webpack_public_path__ + "static/media/video.257718d6.mp4";